// removed by extract-text-webpack-plugin
module.exports = {"select":"_1faGYfzNgoPw2cClrb2H4l"};


//////////////////
// WEBPACK FOOTER
// ./components/EVoucher/style.less
// module id = 1257
// module chunks = 0